import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ViaCheckApiQueryService} from './via-check-api-query.service';
import {DashboardUrl} from '../models/dashboards.interface';

@Injectable({
  providedIn: 'root',
})
export class DashboardsService extends ViaCheckApiQueryService {
  /**
   * @param id is the "CompradorNumeroOrganismo", the id from chilecompras, not MA
   * @returns a string to use as iframe src
   */
  public getDashboard(id: number): Observable<DashboardUrl> {
    const subdomain = `dashboards/5?organismo=${id}`;
    return this.networkRequest('get', subdomain);
  }

  public getQuestionMunicipal(
    compradorNombreOrganismo: string
  ): Observable<DashboardUrl> {
    const subdomain = `dashboards/question/39?muni=${compradorNombreOrganismo}`;
    return this.networkRequest('get', subdomain);
  }

  // TODO: Add a new one that looks for the name of the municipality.

  public getQuestion(id: number): Observable<DashboardUrl> {
    const subdomain = `dashboards/question/${id}`;
    return this.networkRequest('get', subdomain);
  }
}
